import keyMirror from 'keymirror';
import { AppLauncher } from '@capacitor/app-launcher';
import { Browser } from '@capacitor/browser';
import { IS_ANDROID_APP, IS_IOS_APP } from '../../services/capacitor/Constants';
import {
	ANDROID_MARKET_APP_URL,
	APP_STORE_URL,
	GOOGLE_PLAY_URL,
	IOS_MARKET_APP_URL,
} from '../../services/Constants';

export const errorHandlerActionTypes = keyMirror({
	HANDLE_ERROR: null,
	CLEAR_ERROR: null,
});

export const getErrorInfoDependsOfStatusCode = (statusCode, params, t) => {
	if (statusCode === 404) return t(`404.${params}`);
	if (statusCode === 403) return t(`403.${params}`);
	return t(`500.${params}`);
};

export async function navigateToAppStore() {
	const nativeUrl = IS_ANDROID_APP
		? ANDROID_MARKET_APP_URL
		: IS_IOS_APP
			? IOS_MARKET_APP_URL
			: null;
	const webUrl = IS_ANDROID_APP ? GOOGLE_PLAY_URL : IS_IOS_APP ? APP_STORE_URL : GOOGLE_PLAY_URL;

	if (nativeUrl) {
		const { value: canOpen } = await AppLauncher.canOpenUrl({ url: nativeUrl });
		if (canOpen) {
			const { completed } = await AppLauncher.openUrl({ url: nativeUrl });
			if (completed) {
				return;
			}
		}
	}

	if (webUrl) {
		await Browser.open({ url: webUrl });
	}
}
